<template>
  <div class="grid-container pb-5">
    <div class="section-header section-header--xl section-header--dividing mt-3">
      <h1 qaid="contact-us-result-header" class="heading">{{ bp('contactUsTitle') }}</h1>
    </div>

    <pdl-callout qaid="contact-us-result-callout" kind="success">
      <template #content>
        <span v-html="bp('contactUsResponse')" />
      </template>
    </pdl-callout>

    <div class="buttons py-5">
      <trek-link button primary qaid="contact-us-result-submit-another" :href="`${encodedContextPath}/contact-us`">
        <span v-html="bp('submitAnother')"></span>
      </trek-link>
    </div>
  </div>
</template>
<script>
import TrekLink from '@/components/TrekLink';
import {PdlCallout} from '@pedal/pdl-callout';

export default {
  components: {TrekLink, PdlCallout},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    encodedContextPath: {
      type: String,
      default: '',
    },
  },
};
</script>
